import { Box, Stack, Typography, useTheme } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import ButtonBack from 'src/components/common/ButtonBack';
import MainContainer from 'src/components/common/MainContainer';
import BuildUploadResult from 'src/features/AIHSCodeLabeling/BuildUploadResult';
import MainLayout from 'src/layouts';
import { AuthRouteKeys } from 'src/utils/constants/routes';
import { useBulkUploadSearchStore } from 'src/zustand/useAILabelingStore';

const FormBulkUploadStep3 = () => {
  const { dispatch } = useBulkUploadSearchStore();
  const navigate = useNavigate();
  const {
    palette: { divider },
    shape: { borderRadius },
  } = useTheme();
  return (
    <MainLayout>
      <MainContainer>
        <Stack alignItems={'flex-start'} spacing={3}>
          <ButtonBack
            onClick={() => {
              dispatch(1, 'step');
              navigate(AuthRouteKeys.AIHSCodeSearch);
            }}
          />
          <Typography color={'primary.main'} variant="h6">
            Step 3:{' '}
            <Typography display={'inline'} variant="h6" color={'text.primary'}>
              Preview Predictions and Download Your Bulk HS Code File
            </Typography>
          </Typography>

          <Box
            bgcolor={'background.paper'}
            width={'100%'}
            px={2}
            py={4}
            borderRadius={borderRadius}
            border={`1px solid ${divider}`}
          >
            <BuildUploadResult />
          </Box>
        </Stack>
      </MainContainer>
    </MainLayout>
  );
};

export default FormBulkUploadStep3;
